let language = {
    "STORES-HEADER-BUTTON-NEW": "添加商店",
    "STORES-CONTENT-EMPTY-TIPS-1": "你没有任何商店",
    "STORES-CONTENT-EMPTY-TIPS-2-CLICK": "点击这里",
    "STORES-CONTENT-EMPTY-TIPS-3": "添加您的第一个商店。",
    "STORES-CONTENT-SELECT-DESCRIPTION": "选择下面的商店以更改或更新设置。",
    // TABLE
    "STORES-CONTENT-TABLE-HEADER-NAME": "商店名",
    "STORES-CONTENT-TABLE-HEADER-URL": "商店地址",
    "STORES-CONTENT-TABLE-HEADER-CONFIG-SYNC": "配置同步",
    "STORES-CONTENT-TABLE-HEADER-STATE": "商店状态",
    "STORES-CONTENT-TABLE-HEADER-OPERATION": "操作",
    "STORES-CONTENT-OPERATION-SETTING": "修改",
    "STORES-CONTENT-OPERATION-SYNCHRONIZE-CURRENCY": "同步货币",
    "STORES-CONTENT-OPERATION-ORDERS": "客户订单",
    "STORES-CONTENT-OPERATION-PRODUCTS": "商店产品",
    "STORES-CONTENT-OPERATION-EMAIL-SETTING": "发货邮件",
    "STORES-CONTENT-OPERATION-DEFAULT-SHIPPING": "默认配送方式",
    "STORES-CONTENT-CONFIG-SYNCHRONIZING":"同步中",
    // BUTTON
    "STORE-STATUS-BUTTON-ACTIVATE": "启用",
    "STORE-STATUS-BUTTON-CLOSE": "停用店铺",

    // STORE-DETAIL
    "STORES-DETAIL-BASIC-INFOMATION-TITLE": "基本信息",
    "STORES-DETAIL-BASIC-INFOMATION-NAME": "商店名称:",
    "STORES-DETAIL-OTHER-INFOMATION-TITLE": "其他信息",
    "STORES-DETAIL-OTHER-INFOMATION-BILLING": "账单地址:",
    "STORES-DETAIL-OTHER-RERURN-ADDRESS": "退货地址:",
    "STORES-DETAIL-OTHER-INFOMATION-BILLING-SELECT-ADDRESS-BUTTON": "选择地址",
    "STORES-DETAIL-OTHER-INFOMATION-BILLING-SELECT-ADDRESS-EMPTY-TIPS": "没有选择账单地址。",
    "STORES-DETAIL-OTHER-INFOMATION-REFUND": "退货地址:",
    "STORES-DETAIL-OTHER-INFOMATION-REFUND-SELECT-ADDRESS-EMPTY-TIPS": "没有选择退货地址。",
    "STORES-DETAIL-FORM-BUTTON-CANCEL": "取消",
    "STORES-DETAIL-FORM-BUTTON-SAVE": "保存",
    "STORES-DETAIL-QP-TOKEN-INFOMATION": "信息",
    "STORES-DETAIL-QP-TOKEN-INFOMATION-TITLE": "商店令牌:",
    "STORES-DETAIL-QP-TOKEN-INFOMATION-TIPS": "商店令牌已复制！",
    "STORES-DETAIL-BASIC-INFOMATION-URL": "商店网址:",
    "STORES-DETAIL-BASIC-INFOMATION-URL-CLICK-TIPS": "点击查看您的商店:",
    "STORES-DETAIL-WOO-RECONNECT": "您的商店授权有问题。请重新连接您的商店。",
    "STORES-DETAIL-WOO-RECONNECT-BUTTON": "重新授权",
    "STORES-DETAIL-WOO-INFOMATION-TITLE": "WooCommerce 信息",
    "STORES-DETAIL-WOO-INFOMATION-CONSUMER-KEY": "消费者密钥:",
    "STORES-DETAIL-WOO-INFOMATION-CONSUMER-SECRET": "消费者密钥秘钥:",

    // modal
    "STORES-MODAL-RECONNECT-TITLE": "尝试重新连接您的商店。",
    "STORES-MODAL-RECONNECT-BUTTON": "重新连接",
    "STORES-MODAL-GET-TOKEN-TITLE": "显示 {{storeName}} 令牌",
    "STORES-MODAL-GET-TOKEN-PASSWORD": "密码:",
    "STORES-MODAL-GET-TOKEN-BUTTON-CANCEL": "取消",
    "STORES-MODAL-GET-TOKEN-BUTTON-SUBMIT": "提交",
    "STORES-MODAL-SHOW-SUCCESS-INFOMATION-TITLE": "您的商店已成功创建！",
    "STORES-MODAL-SHOW-SUCCESS-INFOMATION-BUTTON": "转到商店列表",

    // new store
    "STORES-SETTING-TAB-INTEGRATION": "集成模式",
    "STORES-SETTING-TAB-CONFIG": "商店配置",
    "STORES-SETTING-TAB-CONNECT": "连接您的商店",
    "STORES-SETTING-API-SHOP-TITLE": "设置商店",
    "STORES-SETTING-API-SHOP-STORE-NAME": "商店名称",
    "STORES-SETTING-API-SHOP-STORE-NAME-TIPS": "无效名称",
    "STORES-SETTING-API-SHOP-STORE-URL": "商店网址",
    "STORES-SETTING-API-SHOP-STORE-URL-TIPS": "无效网址",
    "STORES-SETTING-API-SHOP-BUTTON": "保存",
    "STORES-SETTING-SHOPIFY-SHOP-TITLE": "将您的 Shopify 商店连接到 {{appName}}",
    "STORES-SETTING-SHOPIFY-SHOP-DESCRIPTION": "请按照以下步骤将您的 Shopify 商店连接到您的 {{appName}} 账户。",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-TITLE": "步骤1：创建您的 Shopify 账户",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-1": "如果您还没有 Shopify 账户，请访问 ",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-2": "并注册一个账户。",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-3": "免责声明: {{appName}} 可能会从通过此链接注册或购买中获得佣金。",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-4": "可在此处找到更多信息。",
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-TITLE": "步骤2：在 Shopify 上安装“QPMN POD”应用",
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-1": "1.点击以下链接安装",
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-BUTTON": "安装应用",
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-2": "2.登录您的 Shopify 账户。",
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-3": "3.点击“QPMN POD”应用。",
    "STORES-SETTING-WOOCOMMERCE-SHOP-TITLE": "WooCommerce 信息",
    "STORES-SETTING-WOOCOMMERCE-SHOP-NOTICE": "注意: 请确保您已勾选“启用遗留 REST API”。",
    "STORES-SETTING-WOOCOMMERCE-SHOP-LEARN-MORE": "了解更多...",
    "STORES-SETTING-WOOCOMMERCE-SHOP-AUTHORIZATION": "通过授权连接",
    "STORES-SETTING-WOOCOMMERCE-SHOP-AUTHORIZATION-BUTTON": "保存并进行授权",
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL": "通过手动输入连接",
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL-NOTICE": "注意: 如何设置您的在线商店。",
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL-BUTTON": "查看详情",
    "STORES-SETTING-WOOCOMMERCE-SHOP-CONSUMER-KEY": "消费者密钥:",
    "STORES-SETTING-WOOCOMMERCE-SHOP-CONSUMER-SECRET": "消费者密钥秘钥:",
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL-BUTTON-SAVE": "保存并连接到您的商店",
    "STORES-SETTING-WOOCOMMERCE-SHOP-ONLY-SAVE-TITLE": "仅保存商店信息但不连接",
    "STORES-SETTING-WOOCOMMERCE-SHOP-ONLY-SAVE-BUTTON": "保存为草稿",
    "STORES-SETTING-WOOCOMMERCE-SHOP-EXIST-TITLE": "设置商店",
    "STORES-SETTING-WOOCOMMERCE-SHOP-EXIST-NEXT": "下一步",
    "STORES-SETTING-WOOCOMMERCE-SHOP-EXIST-BUTTON": "保存为草稿",
    "STORES-SETTING-SELECT-MODE-DESCRIPTION": "描述",
    "STORES-SETTING-SELECT-MODE-LEARN-MORE": "了解更多",
    "STORES-SETTING-SELECT-MODE-BUTTON-CONNECT": "连接",
    "STORES-SETTING-SELECT-MODE-WOOCOMMERCE": "WooCommerce / Snapshop",
    "STORES-SETTING-SELECT-MODE-WOOCOMMERCE-DESCRIPTION": `如果您使用 WooCommerce 或 Snapshop，请选择此选项。只需输入您商店的 URL，授权连接，并与 {{appName}} 无缝集成即可开始您的按需印刷业务。`,
    "STORES-SETTING-SELECT-MODE-SHOPIFY-DESCRIPTION": "Shopify 应用提供了您的 Shopify 商店与 {{appName}} 打印按需服务之间的连接。 此集成使您能够通过我们的平台销售定制产品。",
    "STORES-SETTING-SELECT-MODE-API": "Api 集成",
    "STORES-SETTING-SELECT-MODE-SHOPIFY": "Shopify",
    "STORES-SETTING-SELECT-MODE-API-DESCRIPTION": "API 提供了您电子商务平台、服务或自有商店之间的无缝连接，允许您销售在我们的平台上定制的产品，或让您的客户将自己的定制应用于您销售的产品。",
    "STORES-SETTING-SELECT-MODE-BUTTON-CONNECT-THE-SHOP": "连接商店",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-TITLE": "创建 Snap Shop",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-QP": "qpmarkets",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-DESCRIPTION": "是 {{appName}} 的合作伙伴服务，提供了一种简便的方法来设置和托管您的电子商务商店",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-1": "1. 点击“立即创建您的 Snap Shop”按钮进入 qpmarkets。",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-2": "2. 如果您有账户，请登录 qpmarkets，否则在 qpmarkets 上注册一个新账户。",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-3": "3. 在 qpmarkets 上创建一个新的子站点。",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-BUTTON": "立即创建您的 Snap Shop",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-ALREADY-HAVE": "我已经有一个 Snap Shop",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-NOTICE": "注意: 请确保您的站点名称与 Snap Shop 的站点名称相同。",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-SITE": "站点名称",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-SITE-TIPS": "无效名称",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-URL": "商店网址",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-URL-TIPS": "无效网址",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-BUTTON-NEXT": "下一步",
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-BUTTON-DRAFT": "保存为草稿",
    "STORES-SETTING-SELECT-MODE-MANUAL-STORE": '手工店铺',
    "STORES-SETTING-SELECT-MODE-MANUAL-STORE-DESCRIPTION": "允许您在没有连接的商店的情况下创建产品和下订单。 上传您的产品详细信息，并通过Excel发送订单到{{appName}}，以便于管理和履行。 理想的灵活，手动订单处理。",
    "STORES-SETTING-MANUAL-SHOP-TITLE": "店铺信息",
    "STORES-SETTING-MANUAL-SHOP-STORE-NAME": "店铺名称",
    "STORES-SETTING-MANUAL-SHOP-STORE-NAME-PLACEHOLDER": "请输入店铺名称",
    "STORES-SETTING-MANUAL-SHOP-STORE-URL": "店铺地址",
    "STORES-SETTING-MANUAL-SHOP-STORE-BUTTON": "下一步",
    "STORES-SETTING-NAME-REQUIRED-TIPS":"店铺名称必填",
    "STORES-SETTING-NAME-USED-TIPS": "店铺名称已存在",
    "STORES-SETTING-URL-ILLEGAL-TIPS": "请输入一个合法的店铺地址",
    "STORES-SETTING-URL-USED-TIPS": "店铺地址已存在",
    
    "STORES-SETTING-NOT-SUPPORT-CURRENCY-3000608": "您的商店的货币不被支持。",
    "STORES-SETTING-NOT-SUPPORT-CURRENCY-URL": "更改商店的默认货币。",
    "STORES-SETTING-NOT-SUPPORT-CURRENCY-URL-TO": "点击这里",
    "STORES-SETTING-CURRENCY-3000607": "产品货币与商店的货币不同。",
    "STORES-SETTING-CURRENCY-3000607-URL-TO": "点击这里",
    "STORES-SETTING-CURRENCY-3000607-URL": "更新您的货币和定价。",
    "STORES-SETTING-DEFAULT-CURRENCY-INPUT-TITLE": "默认货币：",
    "STORES-SETTING-DEFAULT-CURRENCY-TITLE": "货币",
    "STORES-SETTING-DEFAULT-CURRENCY-EDIT": "编辑",
    "STORES-SETTING-DEFAULT-CURRENCY-TIP": "提示：更新默认货币后，请重新确认产品价格以确保准确性。",
    "STORES-CONTENT-TABLE-HEADER-NAME-CURRENCY": "货币",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY": "从您的电子商店同步默认货币",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-TITLE-300310": "商店同步失败",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-CONTENT-300310": "您商店的默认货币不受支持。请更新您的默认货币设置以继续进行同步。",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-TITLE-300328": "商店同步失败",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-CONTENT-300328": "当前商店配置的认证信息无法被 {{appName}} 访问。请验证并更新您的商店认证设置，以继续进行同步。"


};

export { language }
